import React, { useEffect, useState, useCallback, useRef, memo } from 'react';
import Keyboard from '@components/KeyboardV2';
import { LABEL } from '../../../veriables';
import { lowerCase } from 'lodash';
import { ReactComponent as Cross } from '@assets/images/cross.svg';
import { ReactComponent as SearchIcon } from '@assets/images/SearchDetails.svg';
import cn from 'classnames';
import Styles from '../openCheckPopUp/createtableCopy.module.scss';
import { TouchableButton, TouchableDiv } from '../../common/Touchable/index';

const GuestCountSection = memo(({ count, setCount, serverAppTheme, orderingPortraitOrientation }) => {
  return (
    <div className={cn("col-12 p-0 mx-0 mb-1", !orderingPortraitOrientation ? 'row' : '')}>
      {!orderingPortraitOrientation && (
        <div 
          className="col-6 p-0 row mx-0 my-auto"
          style={{ textAlign: 'initial' }}
        />
      )}
      <div className={cn(!orderingPortraitOrientation ? 'justify-content-end col-6 p-0 row mt-20' : 'justify-content-center d-flex py-0  pr-4')}>
        <div className={cn("fs_24 fw-400 my-1", !orderingPortraitOrientation ? 'text-left pl-4 ml-2' : '')} style={{ color: serverAppTheme?.primary_text }}>
          {LABEL().GUEST_COUNT}
        </div>
        <div className="row ml-3">
          <TouchableButton className={cn(Styles.incDecButton, 'rounded mr-2')} style={{ background: serverAppTheme?.primaryBtn, color: serverAppTheme?.btn_font_color }} onClick={() => count > 1 && setCount(count - 1)} disabled={count <= 1}>
            <i className="fas fa-minus" />
          </TouchableButton>
          <div className="fs_24 fw-700 d-flex align-items-center mx-2" style={{ color: serverAppTheme?.primary_text, width: '15px' }}>{count}</div>
          <TouchableButton className={cn(Styles.incDecButton, 'rounded ml-3')} style={{ background: serverAppTheme?.primaryBtn, color: serverAppTheme?.btn_font_color }} onClick={() => setCount(count + 1)}>
            <i className="fas fa-plus" />
          </TouchableButton>
        </div>
      </div>
    </div>
  );
});

const ActionButtons = memo(({ serverAppTheme, onCloseTable, onContinue, orderingPortraitOrientation }) => {
  return (
    <div className={cn('col-12 d-flex align-items-center justify-content-center position-fixed bottom-0 start-0', Styles.btnPosition)}>
      <div className={cn("pr-1", orderingPortraitOrientation ? 'pl-0 col-6' : 'col-5')}>
        <TouchableButton className={cn('px-0 mb-3 mt-2 rounded btn-ripple fs_24 fw-600 w-100', !orderingPortraitOrientation ? 'btn44' : 'btn68')} style={{ backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font }} onClick={() => onCloseTable('click')} rippleEffect={true}>
          {LABEL().CANCEL}
        </TouchableButton>
      </div>
      <div className={cn("pl-1", orderingPortraitOrientation ? 'pr-0 col-6' : 'col-5')}>
        <TouchableButton className={cn('btn-ripple fs_24 fw-600 w-100 d-flex align-items-center justify-content-center mb-3 mt-2', !orderingPortraitOrientation ? 'btn44' : 'btn68')} style={{ backgroundColor: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }} onClick={onContinue} rippleEffect={true}>
          <span className={cn("fw-600 w-100", !orderingPortraitOrientation ? 'fs_24' : 'fs_28')}>{LABEL().OT_CONTINUE}</span>
        </TouchableButton>
      </div>
    </div>
  );
});

const KeyboardWrapper = memo(({ setKeyboardType, onClickBtn, useAlphaNumericKeypad, keyboardType, setSwipedDown, orderingPortraitOrientation, maxLength, setIsDoneClick, setShowTableSearchField }) => {
  return (
    <div className={cn('w-100 align-items-end position-fixed', !orderingPortraitOrientation ? 'p-0' : 'px-3')} style={{ bottom: !orderingPortraitOrientation ? '70px' : '', left: '0', outline: 'none', top: orderingPortraitOrientation ? '39%' : '' }} onClick={() => setShowTableSearchField && setShowTableSearchField(true)}>
      <Keyboard
        setKeyboardType={setKeyboardType}
        onClickBtn={onClickBtn}
        type={!useAlphaNumericKeypad ? (keyboardType === 'textDefaultCaps' ? 'textDefaultCaps' : 'numericAlpha') : 'textDefaultCaps'}
        closeKeyboard={() => setSwipedDown(false)}
        btnSize="fs-18"
        customClass={`h-auto mt-auto p-2`}
        maxLength={maxLength}
        spacebtn={orderingPortraitOrientation && Styles.spacebtn}
        screenType="checkCreate"
        isAlphaNumericFlag={true}
        setIsDoneClick={setIsDoneClick}
        tableKeyHeight={true}
        callApi={true}
      />
    </div>
  );
});

const TableInputSection = memo(({ 
  submitRef, name, placeholder, isCounter, isDriveThru, deviceGroup, serverAppTheme, 
  searchData, order, showTableSearchField, setShowTableSearchField, maxLength, 
  orderingPortraitOrientation, setErrorPopUp 
}) => {
  const [keyboardType, setKeyboardType] = useState('numericAlpha');
  const [typed, setTyped] = useState({});
  const [inputs, setInputs] = useState({ [name]: '' });
  const [isSwipedDown, setSwipedDown] = useState(true);
  const [isDoneClick, setIsDoneClick] = useState(false);
  const useAlphaNumericKeypad = deviceGroup?.serverAppSettings?.useAlphaNumericKeypad;
  const isSearchEnabled = deviceGroup?.serverAppSettings?.enableTableNumberSearch;

  const typedRef = useRef(typed);
  typedRef.current = typed;
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  const submitInternal = useCallback((guestCount, validate, onSubmit) => {
    const validateData = { ...typedRef.current, guestNumber: guestCount };
    validate(validateData)
      .then(res => {
        if (!res?.isCheckModalOpenFlag) onSubmit(validateData);
      })
      .catch(err => err.message?.length > 0 && setErrorPopUp({ res: err.message, noErrorTxt: true }));
  }, [setErrorPopUp]);

  submitRef.current = submitInternal;

  const onClickBtn = useCallback(e => {
    const currentTyped = typedRef.current;
    if (e === '{continue}') return;
    const value = e === '{bksp}'
        ? { ...currentTyped, [name]: currentTyped[name]?.slice(0, -1) }
        : { ...currentTyped, [name]: (currentTyped[name] || '').concat(e) };
    setTyped(value);
    setInputs(prev => ({ ...prev, [name]: value[name] }));
  }, [name]);

  let filteredArr = [];
  const currentValue = inputs[name] ?? '';
  if (currentValue.length >= 2) {
    filteredArr = searchData?.filter(
      el => !el.tab && el?.stationName && lowerCase(el.stationName).includes(lowerCase(currentValue))
    );
  }

  const getEmployeeFullName = (firstName, lastName, max) => {
    const fullName = (firstName || '') + ' ' + (lastName || '');
    return fullName.length > max ? fullName.substring(0, max) + '...' : fullName;
  };

  return (
    <>
      <div className="col-12 p-0 my-1 mb-0 position-relative">
        <input
          id={name}
          className={cn(Styles.inputField, 'col-12 form-control py-2 text-left fs_26')}
          style={{ background: serverAppTheme?.inputBg, borderBottom: serverAppTheme?.inputBorder_Bottom, color: serverAppTheme?.primary_text, '--placeholder-color': serverAppTheme?.input_placeholder, paddingLeft: isSearchEnabled ? '4rem' : '1rem', outline: 'none', boxShadow: 'none', height: orderingPortraitOrientation ? '64px' : '' }}
          placeholder={placeholder}
          value={inputs[name] || ''}
          onFocus={() => { setSwipedDown(true); (isCounter || isDriveThru) && setKeyboardType('textWithoutNumeric'); }}
          readOnly
        />
        {isSearchEnabled && (
          <div className={cn(Styles.search_icon, 'position-absolute')}>
            <SearchIcon stroke={serverAppTheme?.iconcolor} width={20} height={20} />
          </div>
        )}
        {inputs[name]?.length > 0 && (
          <TouchableDiv className="position-absolute" style={{ right: '18px', top: !orderingPortraitOrientation ? '6px' : '15px' }} onClick={() => { setInputs(prev => ({ ...prev, [name]: '' })); setTyped(prev => ({ ...prev, [name]: '' })); }}>
            <Cross fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}

        {isSearchEnabled && filteredArr?.length >= 1 && showTableSearchField && (
          <div className="w-100 position-absolute overflowY fs_16 pt-1" style={{ backgroundColor: serverAppTheme?.popUp_bg, zIndex: '100', maxHeight: '85px', border: serverAppTheme?.popupBorder, color: 'black', cursor: 'pointer' }}>
            {filteredArr?.map(el => (
              <div key={el.id} style={{ backgroundColor: serverAppTheme?.drop_down_selected, color: serverAppTheme?.primary_text }} className="w-100 d-flex py-1 mb-1" role="button" onClick={() => order(el)}>
                <div style={{ width: '20%' }}>{el?.stationName || el?.stationNumber}</div>
                <div style={{ width: '20%' }}>{el?.number}</div>
                <div style={{ width: '45%' }}>{getEmployeeFullName(el?.employeeFirstName, el.employeeLastName, 18)}</div>
                <div style={{ width: '15%' }}>{LABEL().CURRENCY_SYMBOL + el?.unpaidAmount}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isSwipedDown && (
        <KeyboardWrapper
          setKeyboardType={setKeyboardType}
          onClickBtn={onClickBtn}
          useAlphaNumericKeypad={useAlphaNumericKeypad}
          keyboardType={keyboardType}
          setSwipedDown={setSwipedDown}
          orderingPortraitOrientation={orderingPortraitOrientation}
          maxLength={maxLength}
          setIsDoneClick={setIsDoneClick}
          setShowTableSearchField={setShowTableSearchField}
        />
      )}
    </>
  );
});

const AddTableModal = (props) => {
  const {
    name, placeholder, onSubmit, validate, deviceGroup, orderingPortraitOrientation,
    onCloseTable, serverAppTheme, isCounter, searchData, order,
    showTableSearchField, setShowTableSearchField, isDriveThru, maxLength, setErrorPopUp
  } = props;

  const [count, setCount] = useState(deviceGroup?.defaultGuestCount || 1);
  const submitRef = useRef();

  const handleContinue = useCallback(() => {
    if (submitRef.current) {
      submitRef.current(count, validate, onSubmit);
    }
  }, [count, validate, onSubmit]);

  return (
    <div className={cn(!orderingPortraitOrientation ? 'col-10 p-0 h-100 d-flex flex-column m-auto' : 'col-12 p-0 h-100 d-flex flex-column m-0')}>
      <div className="row align-self-center justify-self-center mb-2 align-items-center justify-content-center mx-3"
           style={{top: orderingPortraitOrientation ? '18vh' : '', position: orderingPortraitOrientation ? 'absolute' : ''}}>
        
        <GuestCountSection count={count} setCount={setCount} serverAppTheme={serverAppTheme} orderingPortraitOrientation={orderingPortraitOrientation} />

        <TableInputSection
          submitRef={submitRef}
          name={name}
          placeholder={placeholder}
          isCounter={isCounter}
          isDriveThru={isDriveThru}
          deviceGroup={deviceGroup}
          serverAppTheme={serverAppTheme}
          searchData={searchData}
          order={order}
          showTableSearchField={showTableSearchField}
          setShowTableSearchField={setShowTableSearchField}
          maxLength={maxLength}
          orderingPortraitOrientation={orderingPortraitOrientation}
          setErrorPopUp={setErrorPopUp}
        />

        <ActionButtons
          serverAppTheme={serverAppTheme}
          onCloseTable={onCloseTable}
          onContinue={handleContinue}
          orderingPortraitOrientation={orderingPortraitOrientation}
        />
      </div>
    </div>
  );
};

export default memo(AddTableModal);
